module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/decorations/deco-blob-8-66d5fd98e01d445cd7ec7dfbb920e54d.svg";